<template>
  <main class="view index">
  </main>
</template>

<script>
  import UserRoles from '@/objects/UserRoles';
  import { Store } from '@/store';

  export default {
    name: 'Index',
    components: {
    },
    //---------------------------------------------------
    //
    //  Properties
    //
    //---------------------------------------------------
    props: {},
    //---------------------------------------------------
    //
    //  Data model
    //
    //---------------------------------------------------
    data() {
      return {
      };
    },
    //---------------------------------------------------
    //
    //  Watch Properties
    //
    //---------------------------------------------------
    watch: {},
    //---------------------------------------------------
    //
    //  Computed Properties
    //
    //---------------------------------------------------
    computed: {
    },
    //---------------------------------------------------
    //
    //  Filter Properties
    //
    //---------------------------------------------------
    filters: {},
    //---------------------------------------------------
    //
    //  Vue Lifecycle
    //
    //---------------------------------------------------
    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // render(h) { return h(); },
    mounted() {
      const role = Store.role;
      if ([UserRoles.OFFICE, UserRoles.OFFICE_ELEVATED, UserRoles.PSYCHOLOGIST, UserRoles.SPD_MANAGER].includes(role)) {
        this.$router.replace('/inquiries');
      } else if (role === UserRoles.VSA_MANAGER) {
        this.$router.replace('/branches');
      }
    },
    // beforeUpdate() {},
    // updated() {},
    // beforeDestroy() {},
    // destroyed() {},
    //---------------------------------------------------
    //
    //  Methods
    //
    //---------------------------------------------------
    methods: {},
  };
</script>

<style lang="scss">
@import '~scss/mixins';
@import '~scss/variables';

.view.index {
}
</style>
